import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/utils/cn'
import {
  shellInsetCardClassName,
  shellPageBackgroundClassName,
  shellMutedPanelClassName,
  shellPageContentClassName,
  shellSurfaceClassName,
} from '@/components/shell/ShellChrome'

export const runPageBackgroundClassName = shellPageBackgroundClassName

export const runPageShellClassName = `relative h-full overflow-y-auto ${runPageBackgroundClassName}`

export const runPageContentClassName = shellPageContentClassName

export const runSurfaceClassName = shellSurfaceClassName

export const runInsetCardClassName = shellInsetCardClassName

export const runMutedPanelClassName = shellMutedPanelClassName

export function RunPageFrame({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={cn(runPageShellClassName, className)}>
      <div className={runPageContentClassName}>{children}</div>
    </div>
  )
}

export function RunSurface({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return (
    <section className={cn(runSurfaceClassName, className)} {...props}>
      {children}
    </section>
  )
}

